import React from 'react';
import { SidebarFloating } from './components/layout/SidebarFloating';
import { Header } from './components/layout/Header';
import { YoneticiDashboard } from './components/dashboard/YoneticiDashboard';
export function App() {
  return <div className="relative overflow-hidden bg-[#000000] text-gray-300 min-h-screen" data-id="element-0">
      <div className="flex flex-col md:flex-row h-screen" data-id="element-1">
        <SidebarFloating data-id="element-2" />
        <div className="flex-1 flex flex-col" data-id="element-3">
          <Header data-id="element-4" />
          <main className="flex-1 overflow-auto p-4 md:p-6 lg:p-8" data-id="element-5">
            <YoneticiDashboard data-id="element-6" />
          </main>
        </div>
      </div>
    </div>;
}